import React from 'react';
import { NavLink } from 'react-router-dom';
import ConfirmModal from '../../../modals/confirmModal.jsx';
import FileSelectionModal from '../../../modals/fileSelectionModal.jsx';
import InformationModal from '../../../modals/infoModal.jsx';
import WarningModal from '../../../modals/warningModal.jsx';
import StatusSelectionModal from '../../../modals/statusSelectionModal.jsx';
import ImportInvoicesModal from '../../../modals/importInvoicesModal.jsx';
import ImportCostsModal from '../../../modals/importCostsModal.jsx';
import TextInputModal from '../../../modals/textInputModal.jsx';
import TripleStateCheckbox from '../../../controls/tripleStateCheckbox.jsx';
import moment from 'moment';
import numeral from 'numeral';
import { apiGet, apiPost } from '../../../services/apiClient';
import { getCurrentUserCompanyId, getRoles } from '../../../services/userRights';
import { multiPrint } from '../../../services/print';
import Grid from '../../../grid/grid.jsx';
import Forbidden from '../../forbidden/forbidden.jsx';
import {toast} from "react-toastify";

export default class AuthorParcelsTable extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            busyCount: 0,
            disableFilters: false,
            lastResponseError: null,
            columns: [
                {
                    renderTitle: () => this.renderSelectionTitle(),
                    fieldName: 'selection',
                    disableSort: true,
                    minWidth: 40,
                    expandPortion: 0,
                    cellClass: "text-center"
                },
                {
                    title: 'Дата создания',
                    fieldName: 'createdDate',
                    filterType: 'date',
                    minWidth: 120
                },
                {
                    renderTitle: () => this.renderNumberTitle(),
                    fieldName: 'number',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'Внешний номер посылки',
                    fieldName: 'externalNumber',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'Тип посылки',
                    fieldName: 'parcelType',
                    filterType: 'dropdown',
                    loadUrl: 'parcels/list/author/ref/parceltypes',
                    minWidth: 120
                },
                {
                    title: 'Вес, кг',
                    fieldName: 'weight',
                    filterType: 'number',
                    minValue: 0,
                    minWidth: 120,
                    cellClass: "text-right"
                },
                {
                    title: 'Себестоимость, руб',
                    fieldName: 'costPrice',
                    filterType: 'number',
                    minValue: 0,
                    minWidth: 140,
                    cellClass: "text-right",
                    isAvailable: () => { return this.isUserGlobalAdmin(); }
                },
                {
                    title: 'Расчетная стоимость доставки',
                    fieldName: 'deliveryCost',
                    filterType: 'number',
                    minValue: 0,
                    minWidth: 120,
                    cellClass: "text-right"
                },
                {
                    title: 'Фактическая стоимость, р. с НДС',
                    fieldName: 'actualDeliveryCost',
                    filterType: 'number',
                    minValue: 0,
                    minWidth: 120,
                    cellClass: "text-right"
                },
                {
                    renderTitle: () => this.renderStatusTitle(),
                    fieldName: 'status',
                    filterType: 'dropdown',
                    loadUrl: 'parcels/list/author/ref/parcelstatuses',
                    minWidth: 160
                },
                {
                    title: 'Фактическая дата отгрузки',
                    fieldName: 'actualDeliveryTime',
                    filterType: 'date',
                    minWidth: 160
                },
                {
                    title: 'Точка отправления',
                    fieldName: 'shipmentPoint',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'Регион точки отправления',
                    fieldName: 'shipmentRegion',
                    filterType: 'dropdown',
                    loadUrl: 'parcels/list/author/ref/shipmentRegions',
                    minWidth: 160
                },
                {
                    title: 'Адрес отправления',
                    fieldName: 'shipmentAddress',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'Контактное лицо отправителя',
                    fieldName: 'senderName',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'Точка доставки',
                    fieldName: 'deliveryPoint',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'Регион точки доставки',
                    fieldName: 'deliveryRegion',
                    filterType: 'dropdown',
                    loadUrl: 'parcels/list/author/ref/deliveryRegions',
                    minWidth: 160
                },
                {
                    title: 'Адрес доставки',
                    fieldName: 'deliveryAddress',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'Контактное лицо получателя',
                    fieldName: 'recipientName',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'Транспортная компания',
                    fieldName: 'carrier',
                    filterType: 'dropdown',
                    loadUrl: 'parcels/list/author/ref/carriers',
                    minWidth: 160
                },
                {
                    title: 'Тип ТС',
                    fieldName: 'vehicleType',
                    filterType: 'dropdown',
                    loadUrl: 'parcels/list/author/ref/vehicleTypes',
                    minWidth: 160
                },
                {
                    title: 'Срочность',
                    fieldName: 'carrierServiceName',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'Желаемая дата и время доставки',
                    fieldName: 'deliveryTime',
                    filterType: 'date',
                    minWidth: 160
                },
                {
                    title: 'Автор посылки',
                    fieldName: 'author',
                    filterType: 'dropdown',
                    loadUrl: 'parcels/list/author/ref/authors',
                    minWidth: 160
                },
                {
                    title: 'Юр. лицо клиента',
                    fieldName: 'company',
                    filterType: 'dropdown',
                    loadUrl: 'parcels/list/author/ref/companies',
                    minWidth: 160
                },
                {
                    title: 'Инициатор',
                    fieldName: 'initiator',
                    filterType: 'dropdown',
                    loadUrl: 'parcels/list/author/ref/initiators',
                    minWidth: 160
                },
                {
                    title: 'Счет',
                    fieldName: 'invoiceNumber',
                    filterType: 'string',
                    minWidth: 120
                },
                {
                    title: 'Сектор',
                    fieldName: 'subCompany',
                    filterType: 'dropdown',
                    loadUrl: 'parcels/list/author/ref/subCompanies',
                    minWidth: 160
                },
                {
                    title: 'Кост центр',
                    fieldName: 'costCenter',
                    filterType: 'dropdown',
                    loadUrl: 'parcels/list/author/ref/costCenters',
                    minWidth: 160
                },
                {
                    title: 'Юр. лицо US',
                    fieldName: 'companyUS',
                    filterType: 'dropdown',
                    loadUrl: 'parcels/list/author/ref/companiesUS',
                    minValue: 0,
                    minWidth: 140,
                    cellClass: "text-left",
                    isAvailable: () => { return this.isUserGlobalAdminOrCoordinator(); }
                },
                {
                    title: 'Источник создания',
                    fieldName: 'source',
                    filterType: 'dropdown',
                    loadUrl: 'parcels/list/author/ref/parcelsources',
                    minWidth: 140,
                    cellClass: "text-left",
                    isAvailable: () => { return this.isUserGlobalAdminOrCoordinator(); }
                }
            ],
            selectedParcelIds: [],
            isSelectedAll: false
        };

        this.confirmDeleteModal = null;
        this.fileSelectionModal = null;
        this.infoModal = null;
        this.warningModal = null;
        this.statusSelectionModal = null;
        this.importInvoicesModal = null;
        this.importCostsModal = null;
        this.textInputModal = null;
    }

    componentDidMount() {
        $('[data-toggle="popover"]').popover();
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    addNew() {
        this.props.history.push('/parcels/new');
    }

    excelImportTemplate() {
        this.updateBusyCount(1);
        apiGet('parcels/import/excel/template')
            .then(data => {
                this.updateBusyCount(-1);
                let fileUrl = getApiBaseUrl() + 'files/' + data.result;
                window.location.href = fileUrl;
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    excelImportTemplateSentParcels() {
        this.updateBusyCount(1);
        apiGet('parcels/import/excel/templateSentParcels')
            .then(data => {
                this.updateBusyCount(-1);
                let fileUrl = getApiBaseUrl() + 'files/' + data.result;
                window.location.href = fileUrl;
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    excelImportUpload() {
        let title = 'Загрузка посылок из Excel';
        this.fileSelectionModal.open(title)
            .then(file => {
                let data = new FormData();
                data.append('file', file);
                this.updateBusyCount(1);
                apiPost('parcels/import/excel/upload', data)
                    .then(() => {
                        this.updateBusyCount(-1);
                        this.reload();
                    })
                    .catch(err => {
                        this.updateBusyCount(-1);
                        if (err.message) {
                            this.infoModal.open(title, err.message);
                        }
                    });
            })
            .catch(() => { });
    }

    excelImportUploadSentParcels() {
        let title = 'Загрузка отправленных посылок из Excel';
        this.fileSelectionModal.open(title)
            .then(file => {
                let data = new FormData();
                data.append('file', file);
                this.updateBusyCount(1);
                apiPost('parcels/import/excel/uploadSentParcels', data)
                    .then(() => {
                        this.updateBusyCount(-1);
                        this.reload();
                    })
                    .catch(err => {
                        this.updateBusyCount(-1);
                        if (err.message) {
                            this.infoModal.open(title, err.message);
                        }
                    });
            })
            .catch(() => { });
    }

    loadData(settings, takeCount, skipCount, needOverlay) {
        this.updateBusyCount(needOverlay ? 1 : 0);
        return apiPost('parcels/list/author/all', { settings: settings, takeCount, skipCount })
            .then(data => {
                this.updateBusyCount(needOverlay ? -1 : 0);
                return data.entries;
            })
            .catch(err => {
                this.updateBusyCount(needOverlay ? -1 : 0);
                if (err.status > 401) {
                    this.setState({ lastResponseError: err.status });
                }
            });
    }

    downloadExcel() {
        this.updateBusyCount(1);
        let settings = this.grid.getSettings();
        apiPost('parcels/list/author/excel', { settings: settings })
            .then(data => {
                this.updateBusyCount(-1);
                let fileUrl = getApiBaseUrl() + 'files/' + data.result;
                window.location.href = fileUrl;
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    loadDataForInvoicing() {
        this.updateBusyCount(1);
        let settings = this.grid.getSettings();
        apiPost('parcels/list/author/invoicing', { settings: settings })
            .then(data => {
                this.updateBusyCount(-1);
                let fileUrl = getApiBaseUrl() + 'files/' + data.result;
                window.location.href = fileUrl;
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    reload() {
        this.handleSelectedAllChange(false);
        this.grid.reload();
    }

    handleRowSelectionChanged(rowId, newChecked) {
        let newSelectedParcelIds = this.state.selectedParcelIds;
        if (newChecked && newSelectedParcelIds.indexOf(rowId) === -1) {
            newSelectedParcelIds.push(rowId);
        } else if (!newChecked) {
            let idIndex = newSelectedParcelIds.indexOf(rowId);
            if (idIndex >= 0) {
                newSelectedParcelIds.splice(idIndex, 1);
            }
        }
        this.setState({
            selectedParcelIds: newSelectedParcelIds,
            isSelectedAll: newSelectedParcelIds.length > 0 ? null : false
        });
    }

    handleSelectedAllChange(newChecked) {
        if (newChecked) {
            this.updateBusyCount(1);
            let settings = this.grid.getSettings();
            this.setState({ disableFilters: true });
            return apiPost('parcels/list/author/ids', { settings: settings })
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState({
                        disableFilters: false,
                        selectedParcelIds: data.ids,
                        isSelectedAll: true
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                    this.setState({ disableFilters: false });
                });
        } else {
            this.setState({
                selectedParcelIds: [],
                isSelectedAll: false
            });
        }
    }

    handleFiltersChange() {
        this.handleSelectedAllChange(false);
    }

    deleteSelectedParcels() {
        let title = 'Удаление посылок';
        let message = 'Вы действительно хотите удалить отмеченные посылки?';
        this.confirmDeleteModal.open(title, message)
            .then(() => {
                this.updateBusyCount(1);
                return apiPost('parcels/list/author/delete', { ids: this.state.selectedParcelIds })
                    .then(data => {
                        this.updateBusyCount(-1);
                        if (data.warnings) {
                            this.infoModal.open(title, data.warnings);
                        }
                        this.reload();
                    })
                    .catch(err => {
                        this.updateBusyCount(-1);
                    });
            })
            .catch(() => { });
    }

    copySelectedParcel() {
        let title = 'Копирование посылок';
        if (this.state.selectedParcelIds.length > 1) {
            this.infoModal.open(title, 'В таблице не должно быть отмечено более одной посылки при копировании.');
        } else {
            let parcelToCopy = this.grid.getRowById(this.state.selectedParcelIds[0]);
            if (parcelToCopy && parcelToCopy.sourceCode === 'SentImport') {
                this.infoModal.open(title, 'Невозможно скопировать посылку, загруженную из шаблона отправленных посылок.');
            } else {
                this.confirmDeleteModal.open(title, 'Вы действительно хотите копировать посылку?')
                    .then(() => {
                        {
                            this.updateBusyCount(1);
                            apiPost('parcels/' + this.state.selectedParcelIds[0] + '/copy')
                                .then(data => {
                                    this.updateBusyCount(-1);
                                    this.reload();
                                    this.setState({
                                        selectedParcelIds: [data.id],
                                        isSelectedAll: null
                                    });
                                })
                                .catch(err => {
                                    this.updateBusyCount(-1);
                                });
                        }
                    })
                    .catch(() => { });
            }
        }
    }

    loadSelectedParcelWaybills() {
        let title = 'Печать накладных';
        this.updateBusyCount(1);
        let request = {
            ids: this.state.selectedParcelIds
        };
        apiPost('parcels/list/documents/waybills', request)
            .then(data => {
                this.updateBusyCount(-1);
                if (!data.entries || data.entries.length < 1) {
                    this.infoModal.open(title, 'Не найдено накладных для печати');
                } else {
                    let files = data.entries.map((entry, ind, arr) => {
                        let fileUrl = getApiBaseUrl() + "parcels/documents/file/" + entry.key + "/download";
                        return {
                            url: fileUrl,
                            contentType: entry.contentType
                        };
                    });
                    multiPrint(files);
                }
            })
            .catch(err => {
                this.updateBusyCount(-1);
                if (err.message) {
                    this.infoModal.open(title, err.message);
                }
            });
    }

    importInvoiceNumbers() {
        this.updateBusyCount(1);
        this.importInvoicesModal.open()
            .then(() => {
                this.updateBusyCount(-1);
                this.reload();
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    importCosts() {
        this.updateBusyCount(1);
        this.importCostsModal.open()
            .then(() => {
                this.updateBusyCount(-1);
                this.reload();
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    importCalc() {
        let title = 'Загрузка массового расчета из Excel';
        this.fileSelectionModal.open(title)
            .then(file => {
                let data = new FormData();
                data.append('file', file);
                this.updateBusyCount(1);
                apiPost('massCalc/importExcel', data)
                    .then(result => {
                        this.updateBusyCount(-1);
                        if (result.message) {
                            this.infoModal.open(title, result.message);
                        }
                    })
                    .catch(err => {
                        this.updateBusyCount(-1);
                        if (err.message) {
                            this.infoModal.open(title, err.message);
                        }
                    });
            })
            .catch(() => { });
    }

    reloadGrid() {
        this.updateBusyCount(-1);
        this.grid.reload();
    }

    editExternalNumber(parcelId, currentValue) {
        
        var title = "Внешний номер посылки";
        this.textInputModal
            .open(title, currentValue)
            .then(newValue => {
                this.updateBusyCount(1);
                let request = {
                    fieldName: 'externalNumber',
                    value: newValue
                };
                apiPost('parcels/' + parcelId + '/field', request)
                    .then(() => {

                        apiPost('parcels/' + parcelId + '/syncDataCarrier')
                            .then(res => {

                                if (res == null || res.notFoundCarrier) {
                                    this.reloadGrid();
                                }
                                else {
                                    if (res.getMessageChange) {
                                        this.infoModal.open(title, res.getMessageChange)
                                            .then(() => {
                                                this.reloadGrid();
                                            });
                                    }
                                    else {
                                        this.reloadGrid();
                                    }
                                }
                            })
                            .catch(err => {
                                this.updateBusyCount(-1);

                                if (err.error) {
                                    this.infoModal.open(title, err.error);
                                }

                                if (err.message) {
                                    this.infoModal.open(title, err.message);
                                }
                            });

                    })
                    .catch(err => {
                        this.updateBusyCount(-1);
                        if (err.error) {
                            this.infoModal.open(title, err.error);
                        }

                        if (err.message) {
                            this.infoModal.open(title, err.message);
                        }
                    });
            });
    }

    bulkChangeStatus() {
        let title = 'Массовая смена статуса посылок';
        this.updateBusyCount(1);
        apiPost('parcels/list/nextstatus/common', { ids: this.state.selectedParcelIds })
            .then(data => {
                if (!data.entries || data.entries.length < 1) {
                    this.updateBusyCount(-1);
                    this.infoModal.open(title, 'Не найдено ни одного статуса, доступного вам для перевода.');
                }
                else {
                    let statuses = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
                    this.statusSelectionModal.open(title, statuses)
                        .then(nextStatus => {
                            let request = {
                                ids: this.state.selectedParcelIds,
                                nextStatus: nextStatus
                            };
                            return apiPost('parcels/list/nextstatus/apply', request)
                                .then(data => {
                                    if (data && data.warningMessages) {
                                        toast.warning(data.warningMessages, {autoClose: 30000});
                                    }
                                    this.updateBusyCount(-1);
                                    this.reload();
                                })
                                .catch(err => {
                                    this.updateBusyCount(-1);
                                    if (err.totalError) {
                                        let title = 'Изменение статусов посылок';
                                        let resultMessage = 'Не соблюдены условия для смены статуса посылки:';
                                        resultMessage += '\n' + err.totalError;
                                        this.infoModal.open(title, resultMessage);
                                    }
                                });
                        })
                        .catch(err => {
                            this.updateBusyCount(-1);
                        });
                }
            })
            .catch(err => {
                this.updateBusyCount(-1);
                if (err.message) {
                    this.infoModal.open(title, err.message);
                }
            });
    }

    renderSelectionTitle() {
        let isBusy = this.state.busyCount > 0;
        return (
            <div className="text-center" style={{ width: "24px" }}>
                <TripleStateCheckbox checked={this.state.isSelectedAll}
                    onChange={e => this.handleSelectedAllChange(e)}
                    disabled={isBusy} />
            </div>
        );
    }

    isUserGlobalAdmin() {
        return getRoles().includes('Admin') || getRoles().includes('GlobalAdmin')
    }

    isUserGlobalAdminOrCoordinator() {
        return this.isUserGlobalAdmin() || getRoles().includes('Coordinator')
    }

    renderNumberTitle() {
        return (
            <div>
                Идентификатор посылки
                <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" data-placement="bottom" title="Идентификатор посылки"
                    data-content="Внутренний номер вашей посылки в системе. Номер накладной транспортной компании находится в поле «Номер накладной ТК».">
                    <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                </a>
            </div>
        );
    }

    renderDeliveryCostTitle() {
        return (
            <div>
                Стоимость доставки
                <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" data-placement="bottom" title="Стоимость доставки"
                    data-content="Стоимость расчетная до статуса посылки «Сумма согласована». После этого статуса сумма фактическая.">
                    <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                </a>
            </div>
        );
    }

    renderStatusTitle() {
        return (
            <div>
                Статус
                <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" data-placement="bottom" title="Статус"
                    data-content="Создана → Отправлена агенту mailroom → Отправлена ТК → Подтверждена ТК → Отгружена → Доставлена → Требует согласования суммы → Сумма согласована → Счет выставлен → Завершена">
                    <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                </a>
            </div>
        );
    }

    checkHighlight(row) {
        return this.state.selectedParcelIds.indexOf(row.id) >= 0;
    }

    renderLastCarrierRequestError(entry) {
        if (entry.lastCarrierRequestError) {
            let title = "Произошла ошибка при отправке заявки транспортной компании: " + entry.lastCarrierRequestError + ". Повторите попытку отправки, изменив статус посылки.";
            return <span className="fa fa-warning text-yellow inline-icon" title={title}></span>;
        } else {
            return null;
        }
    }

    renderExternalNumberCellValue(row, isBusy) {
        let roles = getRoles();
        let isCoordinator = roles.includes('Coordinator');
        let editButton = null;
        if (isCoordinator) {
            editButton = (
                <a role="button"
                    className="icon-tool" 
                    onClick={() => this.editExternalNumber(row.id, row.externalNumber)}
                    disabled={isBusy}
                >
                    <span className="glyphicon glyphicon-pencil"></span>
                </a>
            );
        }

        if (!row.parcelUrl) {
            return <div>{row.externalNumber} {editButton}</div>
        } else {
            return (
                <div>
                    <a href={row.parcelUrl} target="_blank">{row.externalNumber}</a> {editButton}
                </div>
            );
        }
    }

    renderCellValue(row, column) {
        let isBusy = this.state.busyCount > 0;
        switch (column.fieldName) {
            case 'selection':
                return (
                    <input type="checkbox"
                        checked={this.state.selectedParcelIds.indexOf(row.id) >= 0}
                        onChange={e => this.handleRowSelectionChanged(row.id, e.target.checked)}
                        disabled={isBusy}
                    />
                );
            case 'createdDate':
                return moment(row.createdDate).format("DD.MM.YYYY HH:mm");
            case 'number':
                let parcelLink = "/parcels/" + row.id;
                let errorSign = this.renderLastCarrierRequestError(row);
                return (
                    <div>
                        <NavLink to={parcelLink}>
                            {row.number}
                        </NavLink>
                        {errorSign}
                    </div>
                );
            case 'externalNumber':
                return this.renderExternalNumberCellValue(row, isBusy);
            case 'deliveryCost':
                return row.deliveryCost ? numeral(row.deliveryCost).format("0.00") : '';
            case 'actualDeliveryCost':
                return row.actualDeliveryCost ? numeral(row.actualDeliveryCost).format("0.00") : '';
            case 'deliveryTime':
                return row.deliveryTime ? moment(row.deliveryTime).format("DD.MM.YYYY HH:mm") : '';
            case 'actualDeliveryTime':
                return row.actualDeliveryTime ? moment(row.actualDeliveryTime).format("DD.MM.YYYY") : '';
            default:
                return row[column.fieldName];
        }
    }

    renderImportInvoiceNumbersButton(canImport, isBusy) {
        if (canImport) {
            return (
                <div className="btn-group btn-tool">
                    <button type="button"
                        className="btn btn-sm btn-flat btn-default dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        disabled={isBusy}
                    >
                        <span className="glyphicon glyphicon-cloud-upload"></span>
                        <span> Загрузка счета из Excel</span>
                        <span className="caret" style={{ marginLeft: "4px" }}></span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        <li>
                            <a href="/files/Invoices template.xlsx">
                                Скачать шаблон загрузки
							</a>
                        </li>
                        <li>
                            <a onClick={() => this.importInvoiceNumbers()}>
                                Загрузить скачанный шаблон
							</a>
                        </li>
                    </ul>
                </div>
            );
        } else {
            return null;
        }
    }

    renderImportCostsButton(isCoordinator, isBusy) {
        if (isCoordinator) {
            return (
                <div className="btn-group btn-tool">
                    <button type="button"
                        className="btn btn-sm btn-flat btn-default dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        disabled={isBusy}
                    >
                        <span className="glyphicon glyphicon-cloud-upload"></span>
                        <span> Загрузка себестоимости посылки</span>
                        <span className="caret" style={{ marginLeft: "4px" }}></span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        <li>
                            <a href="/files/Delivery costs template.xlsx">
                                Скачать шаблон загрузки
							</a>
                        </li>
                        <li>
                            <a onClick={() => this.importCosts()}>
                                Загрузить скачанный шаблон
							</a>
                        </li>
                    </ul>
                </div>
            );
        } else {
            return null;
        }
    }

    renderCalcExcelImportButton(isAdmin, isBusy) {
        if (isAdmin) {
            return (
                <div className="btn-group btn-tool">
                    <button type="button"
                        className="btn btn-sm btn-flat btn-default dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        disabled={isBusy}
                    >
                        <span className="glyphicon glyphicon-cloud-upload"></span>
                        <span> Массовый расчет</span>
                        <span className="caret" style={{ marginLeft: "4px" }}></span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        <li>
                            <a href="/files/Calculation template.xlsx">
                                Скачать шаблон загрузки
                            </a>
                        </li>
                        <li>
                            <a onClick={() => this.importCalc()}>
                                Загрузить скачанный шаблон
                            </a>
                        </li>
                    </ul>
                </div>
            );
        } else {
            return null;
        }
    }


    render() {
        let roles = getRoles();
        let isAdmin = roles.includes('Admin');
        let isCoordinator = roles.includes('Coordinator');
        let isFinancial = roles.includes('Financial');
        let isAuthor = roles.includes('Author') || isCoordinator;
        let companyId = getCurrentUserCompanyId();

        if (this.state.lastResponseError === 403) {
            return <Forbidden />;
        }

        let isBusy = this.state.busyCount > 0;

        let menuItems = [];
        if (isAuthor && companyId) {
            menuItems.push(<li>
                <a onClick={() => this.addNew()}>
                    Создать посылку
                </a>
            </li>);
            menuItems.push(<li className="divider"></li>);
            menuItems.push(<li>
                <a onClick={() => this.excelImportTemplate()}>
                    Скачать шаблон загрузки
                </a>
            </li>);
            menuItems.push(<li>
                <a onClick={() => this.excelImportUpload()}>
                    Загрузить скачанный шаблон
                </a>
            </li>);
        }
        if (isCoordinator) {
            menuItems.push(<li>
                <a onClick={() => this.excelImportTemplateSentParcels()}>
                    Скачать шаблон загрузки отправленных посылок
                </a>
            </li>);
            menuItems.push(<li>
                <a onClick={() => this.excelImportUploadSentParcels()}>
                    Загрузить скачанный шаблон отправленных посылок
                </a>
            </li>);
        }

        let addNewParcelTool = menuItems.length > 0
            ? (
                <div className="btn-group btn-tool">
                    <button type="button"
                        className="btn btn-sm btn-flat btn-default dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        disabled={isBusy}
                    >
                        <span className="fa fa-plus"></span>
                        <span> Создать посылку</span>
                        <span className="caret" style={{ marginLeft: "4px" }}></span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        {menuItems}
                    </ul>
                </div>
            )
            : null;

        let deleteParcelsTool = isAuthor
            ? (
                <div className="btn-group btn-tool">
                    <a className="btn btn-flat btn-default btn-sm"
                        onClick={() => this.deleteSelectedParcels()}
                        disabled={isBusy || this.state.selectedParcelIds.length === 0}
                    >
                        <span className="fa fa-trash"></span> Удалить посылки
                    </a>
                </div>
            )
            : null;

        let copyParcelsTool = isAuthor
            ? (
                <div className="btn-group btn-tool">
                    <a className="btn btn-flat btn-default btn-sm"
                        onClick={() => this.copySelectedParcel()}
                        disabled={isBusy || this.state.selectedParcelIds.length === 0}
                    >
                        <span className="fa fa-copy"></span> Копировать
                    </a>
                </div>
            )
            : null;

        let bulkChangeStatusTool = (
            <div className="btn-group btn-tool">
                <button type="button"
                    className="btn btn-sm btn-flat btn-default dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="false"
                    disabled={isBusy || this.state.selectedParcelIds.length === 0}
                >
                    <span className="fa fa-edit"></span>
                    <span> Массовые операции</span>
                    <span className="caret" style={{ marginLeft: "4px" }}></span>
                </button>
                <ul className="dropdown-menu" role="menu">
                    <li>
                        <a onClick={() => this.bulkChangeStatus()}>
                            Изменение статуса
						</a>
                    </li>
                </ul>
            </div>
        );

        return (
            <div>
                <section className="content-header">
                    <h1>
                        Посылки
                    </h1>
                    <ol className="breadcrumb">
                        <li className="active"><i className="fa fa-inbox"></i>Посылки</li>
                    </ol>
                </section>
                <section className="content">
                    <div className="box grid-box" style={{ height: this.state.boxHeight }}>
                        <div className="box-header">
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.grid.reload()}
                                    disabled={isBusy}
                                >
                                    <span className="fa fa-refresh"></span>
                                </a>
                            </div>
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.grid.clearSettings()}
                                    disabled={isBusy}
                                >
                                    <span className="glyphicon glyphicon-remove"></span>
                                </a>
                            </div>
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.downloadExcel()}
                                    disabled={isBusy}
                                >
                                    <span className="glyphicon glyphicon-save-file"></span>
                                </a>
                            </div>
                            {addNewParcelTool}
                            {deleteParcelsTool}
                            {copyParcelsTool}
                            {bulkChangeStatusTool}
                            {this.renderImportInvoiceNumbersButton(isCoordinator || isFinancial, isBusy)}
                            {this.renderImportCostsButton(isCoordinator, isBusy)}
                            {this.renderCalcExcelImportButton(isAdmin, isBusy)}
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.loadSelectedParcelWaybills()}
                                    disabled={isBusy || this.state.selectedParcelIds.length === 0}
                                >
                                    <span className="glyphicon glyphicon-print"></span> Печать накладных
                                </a>
                            </div>
                        </div>
                        <div className="box-body">
                            <Grid columns={this.state.columns}
                                loadData={(settings, take, skip, needOverlay) => this.loadData(settings, take, skip, needOverlay)}
                                isBusy={isBusy}
                                disableFilters={this.state.disableFilters}
                                gridKey="parcels"
                                onFiltersChange={() => this.handleFiltersChange()}
                                renderCellValue={(row, column) => this.renderCellValue(row, column)}
                                checkHighlight={row => this.checkHighlight(row)}
                                ref={grid => this.grid = grid}
                            />
                        </div>
                    </div>
                </section>
                <ConfirmModal ref={modal => this.confirmDeleteModal = modal} />
                <FileSelectionModal ref={modal => this.fileSelectionModal = modal} />
                <InformationModal ref={modal => this.infoModal = modal} />
                <WarningModal ref={modal => this.warningModal = modal} />
                <StatusSelectionModal ref={modal => this.statusSelectionModal = modal} />
                <ImportInvoicesModal ref={modal => this.importInvoicesModal = modal} />
                <ImportCostsModal ref={modal => this.importCostsModal = modal} />
                <TextInputModal ref={modal => this.textInputModal = modal} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/table/authorParcelsTable.jsx